import { render, staticRenderFns } from "./ModalAddBank.vue?vue&type=template&id=1fc17d5c&"
import script from "./ModalAddBank.vue?vue&type=script&lang=js&"
export * from "./ModalAddBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports